import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Join from "@/pages/Join";
import Dashboard from "@/pages/Dashboard";
import AuctionDetail from "@/pages/AuctionDetail";
import Members from "@/pages/Members";
import AdminPanel from "@/pages/AdminPanel";
import MyBids from "@/pages/MyBids";
import AuthCallback from "@/pages/AuthCallback";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center font-fredoka">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (!user.is_member) return <Navigate to="/join" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<PublicHome/>} />
      <Route path="/auth/callback" element={<AuthCallback/>} />
      <Route path="/join" element={<RequireLogin><Join/></RequireLogin>} />
      <Route path="/dashboard" element={<Protected><Dashboard/></Protected>} />
      <Route path="/auctions/:id" element={<Protected><AuctionDetail/></Protected>} />
      <Route path="/members" element={<Protected><Members/></Protected>} />
      <Route path="/my-bids" element={<Protected><MyBids/></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><AdminPanel/></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function PublicHome() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center font-fredoka">Loading…</div>;
  if (user && user.is_member) return <Navigate to="/dashboard" replace/>;
  if (user && !user.is_member) return <Navigate to="/join" replace/>;
  return <Login/>;
}

function RequireLogin({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center font-fredoka">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors toastOptions={{
            classNames: {
              toast: "!border-2 !border-black !shadow-brut !rounded-xl !bg-white",
            }
          }}/>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
